import { RefreshCcw, CalendarClock } from "lucide-react";
import { money } from "@/lib/format";

const optionCls = (active) =>
  `flex items-baseline justify-between border p-4 text-left transition-colors duration-200 ${
    active ? "border-forest bg-forest/5" : "border-linen hover:border-pine/40"
  }`;

const methodCls = (active) =>
  `flex items-start gap-3 border p-3.5 text-left transition-colors duration-200 ${
    active ? "border-forest bg-forest/5" : "border-linen hover:border-pine/40"
  }`;

export default function PlanChooser({ label, price, instalments, plan, setPlan, method, setMethod, showRefDiscount, onContinue }) {
  return (
    <div data-testid="paypal-plan-chooser">
      <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.3em] text-terra">Choose how to pay</p>
      <h3 className="mb-6 font-serif text-2xl font-medium leading-tight text-pine">{label}</h3>
      <div className="flex flex-col gap-3">
        <button type="button" data-testid="plan-option-full" onClick={() => setPlan(null)} className={optionCls(!plan)}>
          <span className="text-sm font-medium text-pine">
            Pay in full
            {showRefDiscount && (
              <span className="ml-2 font-mono text-[9px] uppercase tracking-[0.15em] text-terra">10% referral discount</span>
            )}
          </span>
          <span className="font-serif text-xl font-semibold text-forest">{price}</span>
        </button>
        {instalments.map((o) => (
          <button
            key={o.cycles}
            type="button"
            data-testid={`plan-option-${o.cycles}`}
            onClick={() => setPlan(o)}
            className={optionCls(plan?.cycles === o.cycles)}
          >
            <span className="text-sm font-medium text-pine">{o.cycles} monthly payments</span>
            <span className="font-serif text-xl font-semibold text-forest">
              {money(o.amount)}<span className="text-sm font-normal">/mo</span>
            </span>
          </button>
        ))}
      </div>

      {plan && (
        <div className="mt-6 border-t border-linen pt-5">
          <p className="mb-3 font-mono text-[10px] uppercase tracking-[0.25em] text-pine/50">How should the monthly payments work?</p>
          <div className="flex flex-col gap-2.5">
            <button type="button" data-testid="method-auto" onClick={() => setMethod("auto")} className={methodCls(method === "auto")}>
              <RefreshCcw size={15} className="mt-0.5 shrink-0 text-forest" />
              <span className="text-xs leading-relaxed text-pine/80">
                <strong className="block text-sm text-pine">Auto-pay each month</strong>
                Approve once — PayPal charges automatically and stops after the final payment.
              </span>
            </button>
            <button type="button" data-testid="method-manual" onClick={() => setMethod("manual")} className={methodCls(method === "manual")}>
              <CalendarClock size={15} className="mt-0.5 shrink-0 text-forest" />
              <span className="text-xs leading-relaxed text-pine/80">
                <strong className="block text-sm text-pine">Pay monthly myself</strong>
                Pay the first instalment now — we email you a secure payment link each month.
              </span>
            </button>
          </div>
        </div>
      )}

      <button
        type="button"
        data-testid="plan-continue"
        onClick={onContinue}
        className="mt-7 w-full border border-forest bg-forest px-6 py-3.5 font-mono text-xs uppercase tracking-[0.25em] text-bone transition-colors duration-300 hover:bg-transparent hover:text-forest"
      >
        Continue to payment
      </button>
    </div>
  );
}
